var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6665 46.5834H11.3332C8.34317 46.5834 5.9165 44.1567 5.9165 41.1667V32.5001C5.9165 31.8934 6.39317 31.4167 6.99984 31.4167C7.6065 31.4167 8.08317 31.8934 8.08317 32.5001V41.1667C8.08317 42.9651 9.53484 44.4167 11.3332 44.4167H41.6665C43.4648 44.4167 44.9165 42.9651 44.9165 41.1667V32.5001C44.9165 31.8934 45.3932 31.4167 45.9998 31.4167C46.6065 31.4167 47.0832 31.8934 47.0832 32.5001V41.1667C47.0832 44.1567 44.6565 46.5834 41.6665 46.5834Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5456 5.4167C26.8273 5.4167 27.1089 5.52504 27.3039 5.7417L38.1373 16.575C38.5489 17.0084 38.5489 17.68 38.1156 18.1134C37.7039 18.525 37.0323 18.525 36.5989 18.1134L26.5239 8.03837L16.4489 18.1134C16.0156 18.525 15.3439 18.525 14.9106 18.0917C14.4989 17.68 14.4989 17.0084 14.9106 16.575L25.7439 5.7417C25.9389 5.5467 26.2206 5.4167 26.5023 5.4167L26.5456 5.4167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5456 5.41658C27.1522 5.41658 27.6289 5.89325 27.6289 6.49992L27.6289 32.4999C27.6289 33.1066 27.1522 33.5833 26.5456 33.5833C25.9389 33.5833 25.4622 33.1066 25.4622 32.4999L25.4622 6.49992C25.4622 5.89325 25.9389 5.41658 26.5456 5.41658Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3e7a9e5848209c9a242ca0cd185978bf.svg";
export { ForwardRef as ReactComponent };